import React from 'react';
import { Button, Icon, Optional } from '@honda-canada/design-system-react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import themeStyles from '../SummaryBar.styles';
import useAccessoriesData from '../../ConfigureBap/hooks/useAccessoriesData';
import { setCurrentAccessoryModalId } from '../../../core/reducers/ui';
import { selectCurrentVehicle, toggleAccessoryAddQueue, toggleAccessoryRemoveQueue, } from '../../../core/reducers/currentVehicle';
import { useAppSelector } from '../../../core/utils';
import { selectBodyTypesForGtm, selectCurrentVehicleFromVehicles } from '../../../core/reducers/vehicles';
import gtmAddToCustomization from '../../../core/gtm/gtmAddToCustomization';
const CtaButton = themeStyles.apply(Button, 'CtaButton');
const AccessoryModalCta = () => {
    const { t } = useTranslation();
    const { accessories } = useAccessoriesData();
    const dispatch = useDispatch();
    const gtmBodyStyle = useAppSelector(selectBodyTypesForGtm);
    const { inventoryStatus } = useAppSelector(selectCurrentVehicle);
    const currentVehicle = useAppSelector(selectCurrentVehicleFromVehicles);
    const { currentAccessoryModalId } = useAppSelector(state => state.ui.ConfigureBap);
    const selectedAccessory = !!useAppSelector(state => { var _a, _b; return (_b = (_a = state.currentVehicle.accessoryKeys) === null || _a === void 0 ? void 0 : _a.find) === null || _b === void 0 ? void 0 : _b.call(_a, i => i === currentAccessoryModalId); });
    const getAccessoryByBusinessKey = (businessKey) => (accessories === null || accessories === void 0 ? void 0 : accessories.find(a => a.businessKey === businessKey)) || {};
    const currentAccessory = getAccessoryByBusinessKey(currentAccessoryModalId);
    const { isIncluded } = currentAccessory;
    return (React.createElement(Optional, { when: currentAccessoryModalId && !isIncluded },
        React.createElement(Optional, { when: !selectedAccessory },
            React.createElement(CtaButton, { styling: "secondary", onClick: () => {
                    var _a;
                    dispatch(toggleAccessoryAddQueue(currentAccessoryModalId));
                    dispatch(setCurrentAccessoryModalId(''));
                    gtmAddToCustomization({
                        gtmBodyStyle,
                        model: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.modelName,
                        trim: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.trimName,
                        availabilityFlag: inventoryStatus,
                        itemCategory: (_a = currentAccessory === null || currentAccessory === void 0 ? void 0 : currentAccessory.category) === null || _a === void 0 ? void 0 : _a.id,
                        itemName: currentAccessory === null || currentAccessory === void 0 ? void 0 : currentAccessory.name,
                    });
                } },
                React.createElement(Icon, { name: "animatedPlusMinus", testId: "cy-dsr-btn-secondary-icon-animatedPlusMinus" }),
                t('Pages.Bap.addButton'))),
        React.createElement(Optional, { when: selectedAccessory },
            React.createElement(CtaButton, { styling: "primary", onClick: () => {
                    dispatch(toggleAccessoryRemoveQueue(currentAccessoryModalId));
                } },
                React.createElement(Icon, { name: "animatedPlusMinus", color: "white", toggle: true, testId: "cy-dsr-btn-primary-icon-animatedPlusMinus" }),
                t('Pages.Bap.removeButton')))));
};
export default AccessoryModalCta;
